module.exports = __webpack_public_path__ + "static/media/builtinv2-Cabel broken.5a95dfdf.png";